<template>
    <div>
        <dialog-modal :show="newAccount.verificationStep === 1 && newAccount.method === 4" :working="true"  >
        <template #icon>
            <div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                <!-- Heroicon name: exclamation -->
                <svg class="h-6 w-6 text-blue-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
            </div>
        </template>
        <template #title>Ověřování</template>
        <template #content>
            Potvrďte připojení do Vaší datové schránky v aplikaci Mobilní klíč eGovermentu.
        </template>
        <template #footer>
            <jet-secondary-button @click.native="abortMKAuth">
                Zrušit
            </jet-secondary-button>
        </template>
    </dialog-modal>

        <dialog-modal :show="newAccount.processing && newAccount.method === 2" :working="newAccount.working || newAccount.verificationStep === 0 " maxWidth="2xl">
        <template #icon>
            <div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                <!-- Heroicon name: exclamation -->
                <svg class="h-6 w-6 text-blue-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
            </div>
        </template>
        <template #title>Ověřování</template>
        <template #content>
            <div v-if="newAccount.verificationStep === -1">
                Chystáte se přidat datovou schránku "{{ newAccount.username }}".
                Před pokračováním se ujistěte, že <b>ještě nemáte</b> u dané schránky povolen přístup DSchránky.
                V takovém případě nebude možné účet z bezpečnostních důvodů přidat.
            </div>
            <div v-if="newAccount.verificationStep === 0">
                Probíhá ověřování
            </div>
            <div v-if="newAccount.verificationStep === 1">
                <hspis-popup-first/>
            </div>
            <div v-if="newAccount.verificationStep === 2">
                <hspis-popup-second/>
            </div>
            <div v-if="newAccount.verificationStep === 3">
                Probíhá ověřování. Než se projeví změny v nastavení Vaší datové schránky,
                může to trvat až několik minut. Tuto stránku neopouštějte!
            </div>
            <div v-if="newAccount.verificationStep === 4">
                Účet byl úspěšně přidán.
            </div>
        </template>
        <template #footer>
            <jet-button v-if="newAccount.verificationStep !== 0 && newAccount.verificationStep !== 3" @click.native="nextStepHspis">
                Pokračovat
            </jet-button>
            <jet-secondary-button class="mx-2" @click.native="abortHspisAuth">
                Zrušit
            </jet-secondary-button>
        </template>
    </dialog-modal>
    </div>
</template>

<script>
import DialogModal from "../Jetstream/DialogModal";
import SecondaryButton from "../Jetstream/SecondaryButton";
import JetButton from '@/Jetstream/Button'
import HspisPopupFirst from "./HspisPopupFirst";
import HspisPopupSecond from "./HspisPopupSecond";
import {useToast} from "vue-toastification";
export default {
    name: "ISDSAccountAddingGuide",
    components: {HspisPopupSecond, HspisPopupFirst, 'jet-secondary-button': SecondaryButton, DialogModal, JetButton},
    props: ['newAccount', 'mkstart', 'referer'],
    emits: ['mkstarted'],

    data(){
        return {
            MKStartPropCheckInterval: null,
        }
    },
    setup(){
        const toast = useToast();
        return { toast }
    },

    created(){
        this.MKStartPropCheckInterval = setInterval(this.checkMKStart, 500);
    },
    unmounted(){
        if(this.MKStartPropCheckInterval != null) clearInterval(this.MKStartPropCheckInterval);
    },
    destroyed(){
        if(this.MKStartPropCheckInterval != null) clearInterval(this.MKStartPropCheckInterval);
    },

    methods: {
        checkMKStart(){
            if(this.mkstart) {
                this.$emit('mkstarted');
                this.getSCookieMK();
            }
        },

        getSCookieMK(){
            axios.post(route('fapi.isds.mk'), {username: this.newAccount.username, code: this.newAccount.password, step: 1})
                .then( (response) => {
                    this.newAccount.sCookie = response.data.sCookie;
                    this.newAccount.verificationStep = 1;
                    this.mkInterval = setInterval(this.checkMKAccepted, 2000);
                } )
                .catch( (error) => {
                    this.toast.warning('Nesprávné údaje!');
                    this.abortMKAuth();
                } );
        },
        checkMKAccepted(){
            axios.post(route('fapi.isds.mk'), {sCookie: this.newAccount.sCookie, step: 2})
                .then( (response) => {
                    if(response.data.status === 2){
                        this.finalizeMKAuth();
                    }
                    else if(response.data.status === -1 || response.data.status === 3) {
                        this.toast.warning('Požadavek byl odmítnut nebo vypršel. Zkuste to znovu!');
                        this.abortMKAuth();
                    }
                })
                .catch( (error) => {
                    this.toast.warning('Stala se neočekávaná chyba!');
                    this.abortMKAuth();
                } );
        },
        finalizeMKAuth(){
            if(this.mkInterval) clearInterval(this.mkInterval);
            this.$inertia.post(route('settings.progress.user.save'), {
                username: this.newAccount.username,
                password: this.newAccount.password,
                sCookie: this.newAccount.sCookie,
                method: 4,
                referer: this.$props.referer,
            }, { preserveState: false });
        },
        abortMKAuth(){
            if(this.mkInterval) clearInterval(this.mkInterval);
            this.newAccount.verificationStep = 0;
            this.newAccount.processing = false;
            this.newAccount.sCookie = null;
        },

        checkHspisNotAuthenticatedYetAndGetToken(){
            axios.post(route('fapi.isds.hspis'), {username: this.newAccount.username, step: 1, method: 2})
                .then( (response) => {
                    this.newAccount.token = response.data.entry.token;
                    this.newAccount.verificationStep = 1;
                } )
                .catch( (error) => {
                    if(error.response.data.error === 'no-username') this.toast.warning('Nepltné ID datové schránky!');
                    if(error.response.data.error === 'throttle') this.toast.warning('Z bezpečnostních důvodů zkuste tuto schránku přidat později nebo kontaktujte podporu!');
                    if(error.response.data.error === 'registered') this.toast.warning('Před přidáním této schránky odregistrujte certifikát DSchránky!');
                    this.abortHspisAuth();
                } );
        },
        checkHspisAuth(){
            axios.post(route('fapi.isds.hspis'), { username: this.newAccount.username, token: this.newAccount.token, step: 4, method: 2})
                .then( (response) => {
                    this.newAccount.verificationStep = 4;
                    clearInterval(this.hspisInterval);
                    this.hspisTimeout = setTimeout(this.finalizeHspis, 1500);
                } )
                .catch( (error) => {
                    //this.toast.warning('Tento účet nebylo z možné přidat. Zkuste to za 30 minut nebo kontaktujte podporu!');
                    //this.abortHspisAuth();
                } );
        },
        finalizeHspis(){
            this.$inertia.get(route('settings.isds'), {
                step: 4,
                username: this.newAccount.username,
                token: this.newAccount.token,
                method: 2,
                referer: 'settings.isds',
            }, { preserveState: false });
        },
        abortHspisAuth(){
            this.newAccount.verificationStep = 0;
            this.newAccount.processing = false;
            this.newAccount.token = null;
            this.newAccount.working = false;
            clearInterval(this.hspisInterval);
            this.hspisInterval = null;
        },
        nextStepHspis(){
            if(this.newAccount.verificationStep === -1) {
                this.newAccount.verificationStep++;
                setTimeout(this.checkHspisNotAuthenticatedYetAndGetToken, 1000);
            }
            if(this.newAccount.verificationStep === 1)
                this.newAccount.verificationStep++;
            else if(this.newAccount.verificationStep === 2) {
                this.newAccount.working = true;
                this.newAccount.verificationStep++;
                this.hspisInterval = setInterval(this.checkHspisAuth, 10000);
            }
            else if(this.newAccount.verificationStep === 3)
                this.finalizeHspis();
        },
    }
}
</script>

<style scoped>

</style>
